<svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_430_15819)">
<path d="M5.54948 9.16732C7.85067 9.16732 9.71615 7.30184 9.71615 5.00065C9.71615 2.69946 7.85067 0.833984 5.54948 0.833984C3.24829 0.833984 1.38281 2.69946 1.38281 5.00065C1.38281 7.30184 3.24829 9.16732 5.54948 9.16732Z" stroke="black" stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.33594 3.75121C4.4339 3.47274 4.62725 3.23793 4.88175 3.08835C5.13625 2.93878 5.43548 2.8841 5.72643 2.93401C6.01738 2.98392 6.28128 3.13518 6.47139 3.36102C6.66149 3.58685 6.76554 3.87268 6.7651 4.16788C6.7651 5.00121 5.5151 5.41788 5.5151 5.41788" stroke="black" stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.55469 7.08398H5.55885" stroke="black" stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_430_15819">
<rect width="10" height="10" fill="white" transform="translate(0.5625)"/>
</clipPath>
</defs>
</svg>
